// Realistic Apple Health Auto Export sample for the Biometrics preview screen.
// Used when the player hasn't synced yet — gives them a complete picture of what
// the screen will look like with real data, plus shows how every metric feeds
// into the Readiness Score.
export const DEMO_HEALTH_DATA = {
  is_demo: true,
  daily: (() => {
    // Generate the last 14 days, today first → oldest last (we reverse for charts)
    const out = [];
    const baselines = {
      hrv: 64, resting_hr: 56, sleep: 7.4, vo2: 52, steps: 9200,
      active_kcal: 540, hr_max: 178, sleep_rem: 1.8,
    };
    for (let i = 13; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);
      const day = d.toISOString().slice(0, 10);
      // Mild day-to-day variance — simulate a heavy bullpen on day -4 and travel on -2
      const stress = (i === 4 ? 1.2 : i === 2 ? 1.1 : 1) + (Math.sin(i * 1.7) * 0.06);
      out.push({
        date: day,
        hrv_avg:        Math.round(baselines.hrv / stress + Math.cos(i) * 4),
        resting_hr:     Math.round(baselines.resting_hr * stress + Math.sin(i * 0.9) * 2),
        sleep_hours:    +(baselines.sleep / stress + Math.sin(i * 1.1) * 0.35).toFixed(1),
        sleep_rem_hours:+(baselines.sleep_rem + Math.sin(i * 0.6) * 0.25).toFixed(1),
        steps:          Math.round(baselines.steps + Math.cos(i * 1.4) * 2200 + (i === 4 ? 3800 : 0)),
        active_energy_kcal: Math.round(baselines.active_kcal + Math.cos(i) * 90 + (i === 4 ? 220 : 0)),
        vo2_max:        +(baselines.vo2 + Math.sin(i * 0.4) * 1.3).toFixed(1),
        hr_max:         Math.round(baselines.hr_max + Math.cos(i * 0.8) * 5 + (i === 4 ? 8 : 0)),
      });
    }
    return out;
  })(),
  workouts: [
    { date: new Date(Date.now() - 0 * 86400000).toISOString().slice(0, 10),
      name: "Throwing — Bullpen",      duration_sec: 38 * 60,  active_energy_kcal: 285 },
    { date: new Date(Date.now() - 1 * 86400000).toISOString().slice(0, 10),
      name: "Strength — Lower Body",   duration_sec: 55 * 60,  active_energy_kcal: 420 },
    { date: new Date(Date.now() - 2 * 86400000).toISOString().slice(0, 10),
      name: "Recovery Run",            duration_sec: 28 * 60,  active_energy_kcal: 245 },
    { date: new Date(Date.now() - 3 * 86400000).toISOString().slice(0, 10),
      name: "Mobility + Lax Ball",     duration_sec: 18 * 60,  active_energy_kcal: 95  },
    { date: new Date(Date.now() - 4 * 86400000).toISOString().slice(0, 10),
      name: "Throwing — Live BP",      duration_sec: 65 * 60,  active_energy_kcal: 520 },
    { date: new Date(Date.now() - 5 * 86400000).toISOString().slice(0, 10),
      name: "Strength — Upper Body",   duration_sec: 50 * 60,  active_energy_kcal: 380 },
  ],
  webhook_url: null, // not relevant in demo mode
  last_sync: null,
};
